import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { DashboardApp } from './app/dashboard-app.component';

bootstrapApplication(DashboardApp, appConfig)
  .catch((err) => console.error(err));
